import { useEffect, useState } from 'react'

import { i18nReady, isI18nReady } from './localization'

// Never hold the app back for long: a slow/failed chunk just means English.
const MAX_WAIT_MS = 1500

/** False until the startup locale's translations are in, for AppInit to gate its first render. */
const useI18nReady = () => {
  const [ready, setReady] = useState(isI18nReady)

  useEffect(() => {
    if (ready) return
    let active = true
    const done = () => active && setReady(true)
    const timer = setTimeout(done, MAX_WAIT_MS)
    i18nReady.finally(done).catch(() => {})
    return () => {
      active = false
      clearTimeout(timer)
    }
  }, [ready])

  return ready
}

export default useI18nReady
